const evaluationTypes = {
  UnSet: 0,
  Evaluacion_Inicial: 1,
  Evaluacion_Adicional: 2,
  Reevaluacion: 3,
  Evaluacion_Trianual: 4,
  Pruebas_Academicas: 5,
  Pruebas_Academicas_Con_Documentos: 6,
  Centro_Servicio: 12,
};

export default evaluationTypes;
